import { forwardRef } from 'react';
import { styled } from 'goober';
export var IntervalToolbarContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        position: 'relative',
        left: '0',
        right: '0',
        bottom: '0',
        padding: '7px 15px',
        height: '60px',
        alignItems: 'center',
        backgroundColor: 'white',
        justifyContent: 'space-evenly',
    });
});
export var PeriodsContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        gap: '5px',
    });
});
export var PeriodsDivider = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.colors.neutral.w300,
        height: '38px',
        width: '2px',
        margin: '0px 25px',
        transform: 'translateX(-50%)',
    });
});
export var ComparisonAndResetContainer = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        alignSelf: 'flex-start',
    });
});
